import { render, staticRenderFns } from "./NoContent.vue?vue&type=template&id=78a08868&functional=true&"
import script from "./NoContent.vue?vue&type=script&lang=ts&"
export * from "./NoContent.vue?vue&type=script&lang=ts&"
import style0 from "./NoContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports